import * as React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress
        variant="determinate"
        value={props.value}
        sx={{
          height: 10,
          borderRadius: 5,
          transition: 'all 0.3s ease-in-out',
          '& .MuiLinearProgress-bar': {
            transition: 'all 0.3s ease-in-out',
            backgroundColor: '#204887',
          },
          backgroundColor: '#ffffff',
        }}
      />
      <Typography
        variant="caption"
        sx={{
          mt: 0.5,
          display: 'block',
          fontWeight: 500,
          fontSize: '12px',
          color: '#204887',
        }}
      >
        {`${Math.round(props.value)}%`}
      </Typography>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

export default LinearProgressWithLabel;
